<!-- <app-main-navbar></app-main-navbar> -->

<router-outlet></router-outlet>

<app-chat-widget *ngIf="showChatWidget"></app-chat-widget>
<!-- Off-screen PDF render hosts, mounted at app root so generation survives navigation:
     one per in-flight job, each bound to its own frozen tab and self-driving its
     capture → POST → save. Multiple can run at once without their charts crossing over. -->
<div class="pdf-report-host" *ngIf="reportJobs.companyJobs().length">
  <app-company-pdf-report *ngFor="let job of reportJobs.companyJobs(); trackBy: trackByTabId"
    [tabId]="job.tabId"
    [entityids]="job.params?.entityids || null"
    [tab_name]="job.tab_name || null"
    [gsubind]="job.params?.gsubind || null"
    [query]="job.params?.query || null"
    [entityData]="job.params?.entity_data || null"
    (done)="reportJobs.removeCompanyJob($event)">
  </app-company-pdf-report>
</div>

<div class="pdf-report-host" *ngIf="reportJobs.themeJobs().length">
  <app-theme-pdf-report *ngFor="let job of reportJobs.themeJobs(); trackBy: trackByTabId"
    [tabId]="job.tabId"
    [tab_name]="job.tab_name || null"
    [query]="job.params?.query || null"
    [themeParams]="job"
    (done)="reportJobs.removeThemeJob($event)">
  </app-theme-pdf-report>
</div>
